import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'utcToLocal' })
export class UtcToLocalPipe implements PipeTransform {
  transform(utcDate: Date | string | null | undefined): Date | null {
    if (!utcDate) return null;
    const dateStr = typeof utcDate === 'string' ? utcDate : utcDate.toISOString();
    // Append 'Z' to indicate UTC if not already present
    return new Date(dateStr.endsWith('Z') ? dateStr : dateStr + 'Z');
  }
}
